// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"1773edc8","977":"14cd053f"}[chunkId] + ".chunk.js";
};